import { BRANDS } from "@/lib/site";
import { Reveal } from "@/lib/motion";

function Row({ hidden }) {
    return (
        <div aria-hidden={hidden} className="flex items-center shrink-0">
            {BRANDS.map((b) => (
                <span key={b} className="flex items-center whitespace-nowrap">
                    <span className="font-serif italic text-3xl md:text-5xl text-ink/80 px-8 md:px-14">{b}</span>
                    <span className="h-1.5 w-1.5 bg-ink/30 rounded-full" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <section className="border-y border-line py-10 md:py-14 overflow-hidden">
            <Reveal>
                <p className="px-5 md:px-10 pb-8 text-[10px] font-bold uppercase tracking-[0.24em] text-inkdim">
                    Brands &amp; productions — on set, on crew, on record
                </p>
            </Reveal>
            <div className="marquee-track">
                <Row hidden={false} />
                <Row hidden={true} />
            </div>
        </section>
    );
}
